import axiosClient from './axiosClient';

export const getAllVersion = (id?: any): Promise<any> => {
    const url = `${process.env.REACT_APP_PUBLIC_URL}/documents/api/quotes-document/${id}/versions`;
    return axiosClient.get(url);
};
